// Intent: analytics transport for the WEB bundle (and any platform without the
// native SDK). Deliberately a no-op — we never load PostHog on web (dev preview
// only) and never send anything from here. The real transport lives in
// transport.native.ts and is picked by Metro for native builds.

export interface AnalyticsTransport {
  init(): Promise<void>;
  capture(event: string, props?: Record<string, string | number | boolean>): void;
  screen(name: string): void;
  reset(): void;
}

// No-op transport: shape-compatible, does nothing.
export const transport: AnalyticsTransport = {
  async init() {},
  capture() {},
  screen() {},
  reset() {},
};
